// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "home" + "." + "2ea8766598b864944af6" + ".js";
};